<div class="w-full mx-auto h-screen p-5">
  <h1 class="text-2xl font-bold mb-4">Crear Comprobante de Egreso</h1>

  <form [formGroup]="expenseVoucherForm" (ngSubmit)="onSubmit()">

    <!-- BankId -->
    <div class="mb-4">
      <label for="bankId" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Banco</label>
      <!--      <select id="bankId" formControlName="bankId" class="w-full px-3 py-2 border rounded-md">-->
      <!--        <option value="" disabled selected>Seleccione un banco</option>-->
      <!--        <option *ngFor="let bank of banks" [value]="bank.id">-->
      <!--          {{ bank.bankName }} - {{ bank.accountNumber }}-->
      <!--        </option>-->
      <!--      </select>-->
      <p-dropdown id="bankId" formControlName="bankId" [filter]="true" filterBy="label" [showClear]="true"
        [options]="banks" placeholder="Seleccione un banco" class="w-full custom-dropdown">
      </p-dropdown>
      <div *ngIf="expenseVoucherForm.get('bankId')?.invalid && expenseVoucherForm.get('bankId')?.touched"
        class="text-red-500 text-sm">
        Banco es Obligatorio.
      </div>
    </div>

    <!-- ThirdPartiesId -->
    <div class="mb-4">
      <label for="thirdPartiesId" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Tercero</label>
      <!--      <select id="thirdPartiesId" (change)="handleGetWorkOrder($event)" formControlName="thirdPartiesId"-->
      <!--        class="w-full px-3 py-2 border rounded-md">-->
      <!--        <option value="" disabled selected>Seleccione un tercero</option>-->
      <!--        <option *ngFor="let thirdParty of thirdParties" [value]="thirdParty.id">-->
      <!--          Documento: {{thirdParty.documentId}} Nombres: {{ thirdParty.firstName }} {{ thirdParty.lastName }}-->
      <!--        </option>-->
      <!--      </select>-->
      <p-dropdown id="thirdPartiesId" formControlName="thirdPartiesId" [filter]="true" filterBy="label"
        [showClear]="true" [options]="thirdParties" placeholder="Seleccione un tercero"
        (onFilter)="onSearchThirdParties($event)" (onChange)="handleGetWorkOrder($event)"
        class="w-full custom-dropdown">
      </p-dropdown>
      <div
        *ngIf="expenseVoucherForm.get('thirdPartiesId')?.invalid && expenseVoucherForm.get('thirdPartiesId')?.touched"
        class="text-red-500 text-sm">
        Tercero es Obligatorio.
      </div>
    </div>

    <!-- Concept -->
    <div class="mb-4">
      <label for="concept" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Concepto</label>
      <input type="text" id="concept" formControlName="concept" class="w-full px-3 py-2 border rounded-md">
      <div *ngIf="expenseVoucherForm.get('concept')?.invalid && expenseVoucherForm.get('concept')?.touched"
        class="text-red-500 text-sm">
        Concepto es Obligatorio.
      </div>
    </div>

    <!-- DateExpenseVoucher -->
    <div class="mb-4">
      <label for="dateExpenseVoucher" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Fecha en la que se
        efectuó el pago</label>
      <p-calendar id="dateExpenseVoucher" formControlName="dateExpenseVoucher" [showIcon]="true" dateFormat="dd/mm/yy"
        styleClass="w-full" inputStyleClass="w-full px-3 py-2 border rounded-md"></p-calendar>
      <div
        *ngIf="expenseVoucherForm.get('dateExpenseVoucher')?.invalid && expenseVoucherForm.get('dateExpenseVoucher')?.touched"
        class="text-red-500 text-sm">
        Fecha es Obligatorio.
      </div>
    </div>

    <!-- TotalAmount -->
    <div class="mb-4">
      <label for="totalAmount" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Monto Total</label>
      <input type="text" appCurrencyFormatter id="totalAmount" readonly formControlName="totalAmount"
        class="w-full px-3 py-2 border rounded-md">
      <div *ngIf="expenseVoucherForm.get('totalAmount')?.invalid && expenseVoucherForm.get('totalAmount')?.touched"
        class="text-red-500 text-sm">
        Monto Total es Obligatorio.
      </div>
    </div>

    <!-- Expense Voucher Items -->
    <div class="mb-8">
      <h2 class="text-2xl font-bold text-gray-800 mb-6 flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2 text-green-600" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
        Ítems del Comprobante
      </h2>

      <div formArrayName="expenseVouchersItems">
        <ng-container *ngFor="let item of expenseVoucherItems.controls; let i = index">
          <div [formGroupName]="i"
            class="relative bg-white shadow-lg rounded-xl p-6 mb-6 border border-gray-100 hover:shadow-xl transition-shadow">

            <!-- Remove Button -->
            <button (click)="removeExpenseVoucherItem(i)" type="button"
              class="absolute -top-3 -right-3 bg-red-100 hover:bg-red-200 p-2 rounded-full transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-red-600" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <!-- Work Order -->
              <div class="md:col-span-2 lg:col-span-3">
                <label class="block text-sm font-semibold text-gray-700 mb-1">Orden de Trabajo</label>
                <div class="flex gap-2">
                  <select (change)="handleGetDetailsForWorkOrder($event, i)" formControlName="workOrdersId"
                    class="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 border-gray-300">
                    <option value="" disabled selected>Seleccione una orden de trabajo</option>
                    <option *ngFor="let data of workOrders" [value]="data.id">
                      {{data.id}} - {{data.status}}
                    </option>
                  </select>
                  <a *ngIf="expenseVoucherItems.at(i).get('workOrdersId')?.value"
                    [href]="getWorkOrderUrl(expenseVoucherItems.at(i).get('workOrdersId')?.value)" target="_blank"
                    class="flex items-center px-3 py-2 bg-blue-100 text-blue-800 rounded-lg hover:bg-blue-200 transition-colors">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                    Ver
                  </a>
                </div>
              </div>

              <!-- Date -->
              <div>
                <label class="block text-sm font-semibold text-gray-700 mb-1">Fecha</label>
                <input type="text" readonly formControlName="date"
                  class="w-full px-4 py-2 bg-gray-50 border border-gray-200 rounded-lg text-gray-600 italic">
              </div>

              <!-- Payer -->
              <div>
                <label class="block text-sm font-semibold text-gray-700 mb-1">Ordenante Pagador</label>
                <input type="text" readonly formControlName="payer"
                  class="w-full px-4 py-2 bg-gray-50 border border-gray-200 rounded-lg text-gray-600 italic">
              </div>

              <!-- Amounts Section -->
              <div
                class="md:col-span-2 lg:col-span-3 grid grid-cols-2 lg:grid-cols-4 gap-4 pt-4 mt-4 border-t border-gray-200">
                <div>
                  <label class="block text-sm font-semibold text-gray-700 mb-1">Monto Base</label>
                  <div class="relative">
                    <input type="text" appCurrencyFormatter readonly formControlName="totalBaseAmount"
                      class="w-full pl-8 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-lg text-right font-semibold text-gray-800">
                    <span class="absolute left-3 top-2.5 text-gray-500">$</span>
                  </div>
                </div>

                <div>
                  <label class="block text-sm font-semibold text-gray-700 mb-1">IVA</label>
                  <div class="relative">
                    <input type="text" appCurrencyFormatter readonly formControlName="totalVatAmount"
                      class="w-full pl-8 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-lg text-right font-semibold text-red-600">
                    <span class="absolute left-3 top-2.5 text-gray-500">$</span>
                  </div>
                </div>

                <div class="col-span-2 lg:col-span-2">
                  <label class="block text-sm font-semibold text-gray-700 mb-1">Monto Neto</label>
                  <div class="relative">
                    <input type="text" appCurrencyFormatter readonly formControlName="totalToPay"
                      class="w-full pl-8 pr-4 py-2 bg-green-50 border border-green-200 rounded-lg text-right font-bold text-green-700">
                    <span class="absolute left-3 top-2.5 text-green-600">$</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Error Message -->
      <div
        *ngIf="expenseVoucherForm.get('expenseVouchersItems')?.hasError('atLeastOneItemRequired') && expenseVoucherForm.get('expenseVouchersItems')?.touched"
        class="mb-4 flex items-center bg-red-50 p-3 rounded-lg border border-red-200">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-red-600" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <span class="text-red-600 text-sm">Debe agregar al menos un ítem válido</span>
      </div>

      <!-- Add Item Button -->
      <button (click)="addExpenseVoucherItem()" type="button"
        class="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
        Agregar Ítem
      </button>
    </div>

    <!--    Fees Section-->
    <div class="mb-4 p-4 border rounded-lg shadow-sm">
      <h2 class="text-lg font-semibold mb-2">Descuentos</h2>

      <!-- Botón para agregar nuevo Fee -->
      <button type="button" (click)="addFeeDetail()" class="px-4 py-2 bg-blue-500 text-white rounded-md">
        Agregar Fee
      </button>

      <div formArrayName="feeDetails">
        <div *ngFor="let fee of feeDetails.controls; let i = index" [formGroupName]="i"
          class="mt-4 border p-4 rounded-lg shadow">

          <!-- Selección de Tipo de Fee -->
          <label class="block text-gray-700 font-semibold">Tipo de Fee</label>
          <select formControlName="feeTypeId" class="w-full px-3 py-2 border rounded-md">
            <option value="" disabled selected>Seleccione un tipo</option>
            <option *ngFor="let type of feeTypes" [value]="type.id">{{ type.name }}</option>
          </select>

          <!-- Monto -->
          <label class="block mt-2 text-gray-700 font-semibold">Monto</label>
          <input type="text" formControlName="requestAmount" class="w-full px-3 py-2 border rounded-md" />
          <span>Puede añadir el valor fijo ej: 50000 , o puede añadir el valor en porcentaje ej: 10%</span>



          <!-- Descripción -->
          <label class="block mt-2 text-gray-700 font-semibold">Descripción</label>
          <input type="text" formControlName="description" class="w-full px-3 py-2 border rounded-md" />

          <!-- Botón para eliminar -->
          <button type="button" (click)="removeFeeDetail(i)"
            class="mt-2 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600">
            Eliminar
          </button>
        </div>
      </div>
    </div>


    <div class="flex justify-end mt-4">
      <!-- Submit Button -->
      <button type="submit" [disabled]="!expenseVoucherForm.valid" class="bg-blue-500 text-white px-4 py-2 rounded-md">
        Guardar
      </button>
    </div>

  </form>

  <!-- Summary Confirmation Modal -->
  <div *ngIf="showSummaryModal"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 overflow-y-auto">
    <div class="bg-white rounded-lg shadow-xl w-full max-w-2xl mx-4 overflow-hidden animate-fade-in-up">
      <!-- Header -->
      <div class="bg-gray-100 px-6 py-4 border-b border-gray-200 flex justify-between items-center">
        <h3 class="text-xl font-bold text-gray-800">Confirmar Comprobante de Egreso</h3>
        <button (click)="cancelSummary()" class="text-gray-500 hover:text-gray-700 focus:outline-none">
          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Body -->
      <div class="p-6 space-y-4 max-h-[70vh] overflow-y-auto">
        <!-- Información General -->
        <div class="border-b border-gray-200 pb-4 mb-4">
          <h4 class="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3">Información General</h4>
          <div class="grid grid-cols-2 gap-3 text-sm">
            <div>
              <span class="text-gray-600">Banco:</span>
              <div class="font-semibold text-gray-900">{{ getSelectedBankLabel() }}</div>
            </div>
            <div>
              <span class="text-gray-600">Tercero:</span>
              <div class="font-semibold text-gray-900">{{ getSelectedThirdPartyLabel() }}</div>
            </div>
            <div>
              <span class="text-gray-600">Concepto:</span>
              <div class="font-semibold text-gray-900">{{ getExpenseConcept() }}</div>
            </div>
            <div>
              <span class="text-gray-600">Fecha:</span>
              <div class="font-semibold text-gray-900">{{ getFormattedExpenseDate() }}</div>
            </div>
          </div>
        </div>

        <!-- Ítems del Comprobante -->
        <div *ngIf="expenseVoucherItems.length > 0" class="border-b border-gray-200 pb-4 mb-4">
          <h4 class="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">Ítems</h4>
          <div class="overflow-x-auto">
            <table class="w-full text-sm">
              <thead>
                <tr class="text-left text-gray-500 border-b">
                  <th class="py-1 pr-2">OT</th>
                  <th class="py-1 pr-2">Fecha</th>
                  <th class="py-1 pr-2">Ordenante</th>
                  <th class="py-1 text-right">Base</th>
                  <th class="py-1 text-right">IVA</th>
                  <th class="py-1 text-right">Neto</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of expenseVoucherItems.controls" class="border-b border-gray-100">
                  <td class="py-1 pr-2">{{ item.get('workOrdersId')?.value }}</td>
                  <td class="py-1 pr-2">{{ item.get('date')?.value | date:'dd/MM/yy' }}</td>
                  <td class="py-1 pr-2">{{ item.get('payer')?.value }}</td>
                  <td class="py-1 text-right">{{ item.get('totalBaseAmount')?.value | currency:'COP':'symbol-narrow':'1.0-0' }}</td>
                  <td class="py-1 text-right">{{ item.get('totalVatAmount')?.value | currency:'COP':'symbol-narrow':'1.0-0' }}</td>
                  <td class="py-1 text-right font-semibold">{{ item.get('totalToPay')?.value | currency:'COP':'symbol-narrow':'1.0-0' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Subtotal -->
        <div class="flex justify-between items-center text-lg">
          <span class="text-gray-600">Subtotal:</span>
          <span class="font-semibold text-gray-900">{{ summarySubtotal | currency:'COP':'symbol-narrow':'1.0-0'
            }}</span>
        </div>

        <!-- Discounts Section -->
        <div *ngIf="summaryDiscountsList.length > 0" class="border-t border-dashed border-gray-300 pt-4">
          <h4 class="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">Descuentos</h4>
          <div class="space-y-2">
            <div *ngFor="let item of summaryDiscountsList" class="flex justify-between text-sm">
              <div class="flex flex-col">
                <span class="text-gray-700 font-medium">{{ item.name }}</span>
                <span *ngIf="item.description" class="text-xs text-gray-500">{{ item.description }}</span>
                <span class="text-xs text-gray-400">({{ item.originalInput }})</span>
              </div>
              <span class="text-red-600 font-medium">- {{ item.value | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
            </div>

            <div class="flex justify-between items-center pt-2 mt-2 border-t border-gray-100 font-medium text-red-600">
              <span>Total Descuentos:</span>
              <span>- {{ summaryTotalDiscounts | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
            </div>
          </div>
        </div>

        <!-- Total To Pay -->
        <div class="border-t-2 border-gray-800 pt-4 mt-4 flex justify-between items-center">
          <span class="text-xl font-bold text-gray-900">Total a Pagar:</span>
          <span class="text-2xl font-bold text-green-600">{{ summaryNetTotal | currency:'COP':'symbol-narrow':'1.0-0'
            }}</span>
        </div>
      </div>

      <!-- Footer Buttons -->
      <div class="bg-gray-50 px-6 py-4 flex justify-end space-x-3">
        <button (click)="cancelSummary()"
          class="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 font-medium transition-colors">
          Cancelar
        </button>
        <button (click)="confirmSave()"
          class="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 font-bold shadow-md transition-transform transform hover:scale-105">
          Confirmar y Guardar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Confirmación -->
<app-confirmation-modal #confirmationModal [isVisible]="showConfirmationModal" [config]="confirmationConfig"
  (confirmed)="onConfirmationModalConfirmed()" (cancelled)="onConfirmationModalCancelled()"
  (closed)="onConfirmationModalClosed()">
</app-confirmation-modal>